import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import CandlesSection from './pages/CandlesSection';
import WaxMeltsSection from './pages/WaxMeltsSection';
import Collection from './pages/Collection';
import SingleProduct from './pages/SingleProduct';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/candles" element={<CandlesSection />} />
          <Route path="/wax-melts" element={<WaxMeltsSection />} />
          <Route path="/collection/:collectionName" element={<Collection />} />
          <Route path="/product/:productName" element={<SingleProduct />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;